module.exports = __webpack_public_path__ + "static/media/Bones_normal.91479b41.jpg";